import axios from 'axios';

// Determine API URL based on hostname
const isLocalhost = window.location.hostname === 'localhost';
const localApiUrl = `http://localhost:${import.meta.env.VITE_API_PORT || '4000'}`;
const networkApiUrl = import.meta.env.VITE_API_URL; // Read the IP-based URL from .env
const apiUrl = isLocalhost ? localApiUrl : networkApiUrl;

// Determine WebSocket URL based on hostname (optional, if using websockets)
const localWsUrl = `ws://localhost:${import.meta.env.VITE_API_PORT || '4000'}`;
const networkWsUrl = import.meta.env.VITE_WS_URL; // Read the IP-based WS URL from .env
const wsUrl = isLocalhost ? localWsUrl : networkWsUrl;

// Log the determined URLs for debugging
console.log(`Detected hostname: ${window.location.hostname}`);
console.log(`Using API URL: ${apiUrl}`);
console.log(`Using WebSocket URL: ${wsUrl}`); // Log WebSocket URL if relevant

const api = axios.create({
  baseURL: apiUrl, // Use the dynamically determined URL
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 30000
});

// Agregar log para debug de la URL base
console.log('API Base URL:', apiUrl);

// Interceptor para agregar el token a todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//test comment
// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si el error es 401 y no es una petición de refresh o verificación de sesión
    if (error.response?.status === 401 && 
        !originalRequest._retry && 
        !originalRequest.url.includes('/api/auth/me') &&
        !originalRequest.url.includes('/api/auth/refresh')) {
      
      originalRequest._retry = true;

      try {
        // Intentar refrescar la sesión
        const response = await api.post('/api/auth/refresh', {}, {
          withCredentials: true
        });
        
        if (response.data.success) {
          // Reintentar la petición original
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error('Error al refrescar la sesión:', refreshError);
        // Si falla el refresh, redirigir al login
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
        return Promise.reject(refreshError);
      }
    }

    // Manejar otros errores comunes
    if (error.response?.status === 403) {
      console.error('Acceso denegado:', error.response.data);
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    } else if (error.response?.status === 404) {
      console.error('Recurso no encontrado:', error.response.data);
    } else if (error.response?.status === 500) {
      console.error('Error del servidor:', error.response.data);
    }

    return Promise.reject(error);
  }
);

export default api;